import React from 'react';

import { withStyles } from '@material-ui/core/styles';
import MuiTextField from '@material-ui/core/TextField';
import classNames from 'classnames';
import sharedCss from '../../shared/oldDocumentSignerUI/sharedCss';
import fieldStatusClass from './fieldStatusClass';
import truncate from '../../utilities/truncate';

const styles = theme => ({
  ...sharedCss.fields,
  textField: {
    position: 'absolute',
  },
  input: {
    paddingLeft: '5px',
    paddingRight: '5px',
  },
});

const NumberField = props => {
  const {
    id,
    name,
    x,
    y,
    height,
    width,
    handleChange,
    classes,
    value = '',
    setFieldRef,
    max,
    _derived: { isRequired, isDisabled },
  } = props;

  const fieldDynamicStyle = {
    top: y,
    left: x,
    height,
    width,
  };
  const inputClass = classNames(classes.input, fieldStatusClass(props));

  const onChange = ({ target: { value } }) => {
    value = `${value}`.replace(/[^0-9.-]+/g, '');
    value = truncate(value, max);
    handleChange(value);
  };

  return (
    <MuiTextField
      id={name}
      inputRef={e => setFieldRef(e, y)}
      inputMode="numeric"
      pattern="[0-9]*"
      className={classes.textField}
      value={value === null || value === undefined ? '' : value}
      style={fieldDynamicStyle}
      type="text"
      onChange={onChange}
      margin="none"
      disabled={isDisabled}
      data-test-id={`NumberField-root-${id}`}
      placeholder={isRequired ? 'Required' : ''}
      InputProps={{
        disableUnderline: isDisabled,
        classes: {
          input: inputClass,
        },
        inputProps: {
          'data-test-id': `NumberField-input-${id}`,
        },
      }}
    />
  );
};

export default withStyles(styles)(NumberField);
